import { LitElement } from 'lit';
import { WizardElementBehavior } from './fit-wizard-element-behavior';
import { updateIbeUrl } from './actions';

const excludedParams = ['id', 'dom', 'cHash', 'results', 'args', 'viewMode'];

class FitWizardQuerySync extends WizardElementBehavior(LitElement) {
  static get is() { return 'fit-wizard-query-sync'; }

  static get properties() {
    return {
      ibeUrl: {
        type: String,
        attribute: 'ibe-url',
      },
    };
  }

  get searchParams() {
    const url = new URL(document.location.href);
    return new URLSearchParams(url.search);
  }

  // No shadow dom necessary
  createRenderRoot() { return this; }

  constructor(props) {
    super(props);
    this._lastDispatchedIbeUrl = '';
    this.hidden = true;
    this.fieldName = 'ibeUrl';
    this.updateIbeUrlFromLocation = this.updateIbeUrlFromLocation.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('popstate', this.updateIbeUrlFromLocation);
    this.updateIbeUrlFromLocation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('popstate', this.updateIbeUrlFromLocation);
  }

  stateChanged(state) {
    if (state.hasOwnProperty('ibeUrl')) {
      this.updateLocationFromIbeUrl(state.ibeUrl);
    }
  }

  updateIbeUrlFromLocation() {
    const { searchParams } = this;
    excludedParams.forEach((excludedParams) => { searchParams.delete(excludedParams); });
    this.dispatchAction(updateIbeUrl(this._lastDispatchedIbeUrl = searchParams.toString()));
  }

  updateLocationFromIbeUrl(ibeUrl) {
    if (this._lastDispatchedIbeUrl === ibeUrl) {
      return;
    }

    const currentSearchParams = this.searchParams;
    const newSearchParams = new URLSearchParams(ibeUrl);

    // Add excluded params to new params
    excludedParams.forEach((excludedParam) => {
      if (currentSearchParams.has(excludedParam)) {
        newSearchParams.append(excludedParam, currentSearchParams.get(excludedParam));
      }
    });

    // Normalize by stable sorting for comparison
    currentSearchParams.sort();
    const newSortedSearchParams = new URLSearchParams(newSearchParams);
    newSortedSearchParams.sort();

    // Check as a circuit breaker whether the urls actually differ
    if (currentSearchParams.toString() !== newSortedSearchParams.toString()) {
      const url = (new URL(document.location.href));
      url.search = newSearchParams.toString();

      window.history.pushState({}, '', url);
    }
  }
}

customElements.define(FitWizardQuerySync.is, FitWizardQuerySync);
